var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTickCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66666C5.40964 1.66666 1.66797 5.40832 1.66797 9.99999C1.66797 14.5917 5.40964 18.3333 10.0013 18.3333C14.593 18.3333 18.3346 14.5917 18.3346 9.99999C18.3346 5.40832 14.593 1.66666 10.0013 1.66666ZM13.9846 8.08332L9.25964 12.8083C9.14297 12.925 8.98464 12.9917 8.81797 12.9917C8.6513 12.9917 8.49297 12.925 8.3763 12.8083L6.01797 10.45C5.7763 10.2083 5.7763 9.80832 6.01797 9.56666C6.25964 9.32499 6.65964 9.32499 6.9013 9.56666L8.81797 11.4833L13.1013 7.19999C13.343 6.95832 13.743 6.95832 13.9846 7.19999C14.2263 7.44166 14.2263 7.83332 13.9846 8.08332Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleFilled);
export default __webpack_public_path__ + "static/media/tick_circle_filled.d8b7f445.svg";
export { ForwardRef as ReactComponent };